import React from 'react';
import OlMap from 'ol/Map.js';
// import OlMap from 'ol/WebGLMap';
import View from 'ol/View.js';
import OSM from 'ol/source/OSM.js';
import { translate } from 'react-i18next';
import { Tile as TileLayer } from 'ol/layer.js';
import { transform } from 'ol/proj.js';
import { connect } from 'react-redux';
import { dispatch } from '@ro-store';
import Icon from '@ro-atoms/Icon';
import { withRouter } from 'react-router-dom';
import Geolocation from 'ol/Geolocation.js';
import Themes from '@ro-sources/themes';
import { setLayerVisibility, setLayerOpacity, setLayerIndex } from '@ro-utils/common/helpers';
import chroma from 'chroma-js';
import { bindOlEvents } from '@ro-utils/common/map/events';
// import { defaults as defaultInteractions, PinchZoom } from 'ol/interaction';

import {
  ESTOFEX_FORMAT,
  RADAR_FORMAT,
  RADAR_START_DATE,
  LAYER_RADAR,
  LAYER_ESTOFEX,
  LAYER_SKYPREDICT,
  LAYER_SNOW_COVER,
  LAYER_SYNOP,
  LAYER_DETECTOR,
  LAYER_ESTOFEX_MARKER
} from '@ro-utils/constant';

import { setRadarMarkers } from '@ro-utils/common/map/polrad';

import Tile from '@ro-components/Tile';
import Slider from '@ro-components/Slider';
//import ScreenStrikes from '@ro-components/ScreenStrikes';
import SnowCover from '@ro-components/SnowCover';
import WeatherStations from '@ro-components/WeatherStations';
import { RoSliderWrapper } from '@ro-atoms/Slider/RoSlider/RoSlider.styles';
import Lightnings from '@ro-components/Lightnings';
import SkyPredict from '@ro-components/SkyPredict';
import Estofex from '@ro-components/Estofex';
import Legend from '@ro-components/Legend';
import moment from 'moment';
import InProgress from '@ro-containers/InProgress';

import { withTimezone } from '@ro-utils/common/radar-params';

import { MapWrapper, Statuses, StatusItem, HelpButton, FBLIke, Attribution } from './Map.styles';

import { setDataFromUrl } from '@ro-utils/common/helpers';

class Map extends React.Component {
  constructor(props) {
    super(props);
    const { ol: map } = this.props;
    global.RO_IMAGES = {};
    this.state = {
      screenStrikes: [],
      openedModal: true
    };

    if (!this.map) {
      this.view = new View({
        ...map.view,
        center: transform(map.view.center, 'EPSG:4326', 'EPSG:3857'),
        constrainResolution: true
      });
      this.tile = new TileLayer({
        ...map.tile,
        source: new OSM(),
      });
      this.map = new OlMap({
        ...map.map,
        layers: [this.tile],
        view: this.view,
        pixelRatio: 1,
      });
      this.geolocation = new Geolocation({
        trackingOptions: {
          enableHighAccuracy: true
        },
        projection: this.view.getProjection()
      });

      // this.geolocation.on('change:position', () => {
      //   const coordinates = this.geolocation.getPosition();
      //   userSettings.geolocation && dispatch.ro.setCurrentLocation(
      //     setCoord(transform(coordinates, 'EPSG:3857', 'EPSG:4326'), '', { date, mapType, anchor: userSettings.anchor })
      //   );
      //   animationByCoord(coordinates);
      // });

      global.RO_GEOLOCATION = this.geolocation;
      bindOlEvents(this, dispatch.ro.setCurrentLocation, dispatch.ro.setCurrentRotation);
    }
  }

  componentDidMount() {
    this.map && setDataFromUrl(window.location, dispatch);
    this.map && setRadarMarkers(this.map);
  }

  getEstofexData() {
    const { estofexData, currentEstofexData, date } = this.props;
    if (date) {
      return estofexData;
    } else {
      const diff = moment(currentEstofexData.expiryTime, ESTOFEX_FORMAT).diff(moment());
      return diff > 0 && currentEstofexData;
    }
  }
  render() {
    const {
      lightningsData,
      userSettings,
      radarData,
      skyPredictData,
      snowCoverData,
      synopData,
      date,
      mapType,
      t
    } = this.props;

    const { pathname } = this.props.location;

    const estofexData = this.getEstofexData();

    const isArchive = date;
    const isInactiveRadar = RADAR_START_DATE > date && !!date;

    const visibilities = {
      radar: {
        active: Boolean(radarData) && Boolean(userSettings.visibility.radar),
        inactive: isInactiveRadar,
        hidden: !Boolean(userSettings.visibility.radar)
      },
      snow: {
        active: !isArchive && Boolean(userSettings.visibility.snow),
        inactive: isArchive,
        hidden: !Boolean(userSettings.visibility.snow)
      },
      synop: {
        active: !isArchive && Boolean(userSettings.visibility.synop),
        inactive: isArchive,
        hidden: !Boolean(userSettings.visibility.synop)
      },
      skypredict: {
        active: !isArchive && Boolean(userSettings.visibility.sp),
        inactive: isArchive,
        hidden: !Boolean(userSettings.visibility.sp)
      },
      estofex: {
        active: estofexData && Boolean(userSettings.visibility.estofex),
        inactive: !Boolean(estofexData),
        hidden: !Boolean(userSettings.visibility.estofex)
      },
      detector: {
        active: lightningsData && Boolean(userSettings.visibility.lightnings),
        inactive: isArchive,
        hidden: !Boolean(userSettings.visibility.lightnings)
      }
    };

    if (this.map) {
      userSettings.geolocation && this.geolocation.setTracking(true);
      setLayerVisibility(!visibilities.radar.hidden, LAYER_RADAR, this.map);
      setLayerOpacity(userSettings.radar.opacity, LAYER_RADAR, this.map);
      setLayerVisibility(!visibilities.synop.hidden && !isArchive, LAYER_SYNOP, this.map);
      setLayerVisibility(!visibilities.snow.hidden, LAYER_SNOW_COVER, this.map);
      setLayerVisibility(!visibilities.detector.hidden, LAYER_DETECTOR, this.map);
      setLayerVisibility(!visibilities.skypredict.hidden, LAYER_SKYPREDICT, this.map);
      setLayerVisibility(!visibilities.estofex.hidden, LAYER_ESTOFEX_MARKER, this.map);
      setLayerVisibility(!visibilities.estofex.hidden, LAYER_ESTOFEX, this.map);

      setLayerIndex(userSettings.layersIndex.radar, LAYER_RADAR, this.map);
      setLayerIndex(userSettings.layersIndex.synop, LAYER_SYNOP, this.map);
      setLayerIndex(userSettings.layersIndex.snow, LAYER_SNOW_COVER, this.map);
      setLayerIndex(userSettings.layersIndex.detector, LAYER_DETECTOR, this.map);
      setLayerIndex(userSettings.layersIndex.skypredict, LAYER_SKYPREDICT, this.map);
      setLayerIndex(userSettings.layersIndex.estofex, LAYER_ESTOFEX_MARKER, this.map);
      setLayerIndex(userSettings.layersIndex.estofex, LAYER_ESTOFEX, this.map);
    }

    global.RO_MAP = this.map;

    const formatDate = 'DD/MM/YYYY HH:mm:ss';
    const startDate = lightningsData && withTimezone(lightningsData.range[0], formatDate);
    const endDate = lightningsData && withTimezone(lightningsData.range[1], formatDate);

    const rangeDate = (moment(endDate, formatDate).valueOf() - moment(startDate, formatDate).valueOf()) / 60000 + 1;

    return (
      <MapWrapper>
        {userSettings.oldRadarModal && userSettings.tutorialLevel === false && pathname === '/' && (
          <InProgress
            customCloseAction={() => dispatch.ro.closeOldRadarModal(false)}
            acceptAndClose={() => dispatch.ro.closeOldRadarModalPermanently(false)}
          />
        )}
        <FBLIke>
          <div
            class="fb-like"
            data-href="https://www.facebook.com/radaropadow"
            data-width=""
            data-layout="button_count"
            data-action="like"
            data-size="large"
            data-share="false"
          />
        </FBLIke>
        <Attribution>
          <div
            dangerouslySetInnerHTML={{ __html: Themes[userSettings.tile].attribution }}  
          />
        </Attribution>
        <a href={'https://zrzutka.pl/z/radar-opadow'} target="_blank" rel="noopener noreferrer">
          <HelpButton size="small" color="primary" variant="contained">
            <i class="fas fa-heart" aria-hidden="true"></i>&nbsp;&nbsp;Pomóż i zostań patronem RO!
          </HelpButton>
        </a>
        <Statuses>
          {Object.keys(visibilities).map(item => {
            return (
              <StatusItem visibility={visibilities[item]}>
                <Icon name={t(`icons.controls.${item}`)} />
              </StatusItem>
            );
          })}
        </Statuses>
        {!visibilities.snow.hidden ? (
          <SnowCover data={snowCoverData} map={this.map} index={userSettings.layersIndex.snow} />
        ) : null}
        {!visibilities.synop.hidden ? (
          <WeatherStations
            data={synopData}
            map={this.map}
            type={userSettings.synopType}
            index={userSettings.layersIndex.synop}
          />
        ) : null}
        <RoSliderWrapper className="ro_tool_anim_data">
          {radarData && (
            <Slider
              lightningsData={lightningsData}
              synopData={synopData}
              snowCoverData={snowCoverData}
              map={this.map}
              radarData={radarData}
            />
          )}
        </RoSliderWrapper>
        {!visibilities.detector.hidden
          ? lightningsData && (
              <Lightnings
                tile={this.tile}
                date={date}
                strikes={lightningsData}
                map={this.map}
                settings={{
                  ...userSettings.lightnings,
                  index: userSettings.layersIndex.detector
                }}
                palette={chroma
                  .scale(userSettings.lightnings.interpolation)
                  .mode('lch')
                  .colors(rangeDate)}
                interpolation={userSettings.lightnings.interpolation}
                startDate={moment(startDate, formatDate).format(RADAR_FORMAT)}
                endDate={moment(endDate, formatDate).format(RADAR_FORMAT)}
              />
            )
          : null}
        {!visibilities.skypredict.hidden && (
          <SkyPredict
            data={visibilities.skypredict.active && skyPredictData}
            settings={{
              ...userSettings.sp,
              index: userSettings.layersIndex.skypredict
            }}
            map={this.map}
          />
        )}
        {!visibilities.estofex.hidden && (
          <Estofex
            data={visibilities.estofex.active && estofexData}
            settings={{
              ...userSettings.estofex,
              index: userSettings.layersIndex.estofex
            }}
            map={this.map}
            date={date}
          />
        )}
        <Legend mapType={mapType} />
        <Tile defaultTile={userSettings.tile} map={this.map} tile={this.tile} />
        {/* <ScreenStrikes map={this.map} lightningsData={lightningsData} /> */}
      </MapWrapper>
    );
  }
}

const mapStateToProps = ({ ro }) => {
  const { radarData, date, currentData } = ro;
  const chosenRadarData = date ? radarData : currentData;
  return {
    ...ro,
    radarData: chosenRadarData
  };
};

export default withRouter(connect(mapStateToProps)(translate('common')(Map)));
